import { render, staticRenderFns } from "./JamFilter.vue?vue&type=template&id=56635565&scoped=true"
import script from "./JamFilter.vue?vue&type=script&lang=js"
export * from "./JamFilter.vue?vue&type=script&lang=js"
import style0 from "./JamFilter.vue?vue&type=style&index=0&id=56635565&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56635565",
  null
  
)

export default component.exports